export default __webpack_public_path__ + "static/media/portail-inscription-formations.5bc9244d.png";